"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseAgencies = exports.InputFilterAgencies = exports.ListAgencies = exports.Agency = exports.OpeningTime = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
/**
 * Abstract class for all the responses of the remote service
 */
class ServiceResponse {
    constructor(codeResponse, descResponse) {
        this.codeResponse = codeResponse;
        this.descResponse = descResponse;
    }
    getCodeResponse() {
        return this.codeResponse;
    }
    getDescResponse() {
        return this.descResponse;
    }
}
class OpeningTime {
}
exports.OpeningTime = OpeningTime;
class Agency {
    constructor() {
        this.isMyAgency = false;
        this.isDestination = false;
        this.openModalFlag = false; /* Utilizzato per gestire l'apertura della Modal al posto della InfoWindow */
        this.setIconByCategory(false)
            .then((value) => {
            this.iconUrl = value;
        })
            .catch((value) => console.error(new Error().stack));
    }
    setIconByCategory(select) {
        return nodejs_library_1.Helpers.SessionHelper.getData("categoryAgency")
            .then((category) => {
            if (category) {
                if (/CARR|MYGLASS|CENTRO/i.test(category)) {
                    return !select
                        ? "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/loc_mobility-02.png"
                        : "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/loc_mobility-01.png";
                }
                else {
                    return !select
                        ? "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/Risorsa4.png"
                        : "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/Risorsa2.png";
                }
            }
            return select
                ? "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/map_marker_selected.png"
                : "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/map_marker_unselected.png";
        })
            .catch(() => {
            return select
                ? "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/map_marker_selected.png"
                : "/UnipolSaiThemeDynamicWAR/themes/html/dynamicSpots/assets/images/locator/map_marker_unselected.png";
        });
    }
}
exports.Agency = Agency;
/**
 * List Agencies Wrapper
 */
class ListAgencies {
}
exports.ListAgencies = ListAgencies;
class InputFilterAgencies {
    constructor() {
        this.categoryAgency = "";
        this.divisionCode = "";
        this.lat = "";
        this.lng = "";
        this.neLat = "";
        this.neLng = "";
        this.swLat = "";
        this.swLng = "";
        this.maxItem = "10";
        this.itemType = "";
        this.brandCode = "";
        this.callback = "";
        this.filters = []; // currently not used
        this.codiceAgenzia = "";
        this.pro = "";
    }
}
exports.InputFilterAgencies = InputFilterAgencies;
// End Model Agencies
/**
 * Remote response for Agencies Services
 */
class ResponseAgencies extends ServiceResponse {
    constructor(codeResponse, descResponse) {
        super(codeResponse, descResponse); // constructors in derived classes must call super()
        this.codeResponse = codeResponse;
        this.descResponse = descResponse;
        this.listAgenciesWrapper = null;
    }
    setResponseObject(listAgenciesWrapper) {
        this.listAgenciesWrapper = listAgenciesWrapper;
    }
    getResponseObject() {
        return this.listAgenciesWrapper;
    }
}
exports.ResponseAgencies = ResponseAgencies;
/** END AGENCIES **/ 
